import { PDFDownloadLink, Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    padding: 5,
  },
  container: {
    border: "1pt solid black",
    padding: 8,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  disclaimer: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 15,
    color: "#666666",
  },
  content: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    paddingHorizontal: 10,
  },
  brand: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#333333",
  },
  grade: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#000000",
  }
});

const GradeSticker = ({ gradeValue }) => (
  <Document>
    <Page size={[180, 108]} style={styles.page}>
      <View style={styles.container}>
        <Text style={styles.disclaimer}>Not an official grade</Text>
        <View style={styles.content}>
          <Text style={styles.brand}>Fast Grades</Text>
          <Text style={styles.grade}>{gradeValue}</Text>
        </View>
      </View>
    </Page>
  </Document>
);
const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};
const PDFDownloadButton = ({ gradeValue }) => (
  <PDFDownloadLink
    document={<GradeSticker gradeValue={gradeValue} />}
    fileName={`fastgrade-${gradeValue}-${getFormattedDate()}.pdf`}
  >
    Download Grade Sticker
  </PDFDownloadLink>
);

export default PDFDownloadButton;
